import React from "react";
import { useAdminContext } from "../provider/AdminContext";
import DrilldownHeader from "./DrilldownHeader";

const CompanyDetail = () => {
  const { selectedCompany, companyUsers, companyProjects, openUsers, openProjects } =
    useAdminContext();

  return (
    <div className="w-full h-full overflow-y-auto">
      <div className="bg-gray-50 p-3 sm:p-4 md:p-6">
        <div className="max-w-5xl mx-auto">
          <DrilldownHeader
            title={selectedCompany?.companyName || "Company"}
            breadcrumbs={["All Companies"]}
          />

          <div className="grid gap-6 sm:grid-cols-2">
            <div
              onClick={openUsers}
              className="bg-white rounded-lg shadow-md border border-gray-200 p-6 hover:shadow-lg transition-shadow cursor-pointer text-center"
            >
              <div className="text-4xl font-bold text-blue-600 mb-2">
                {companyUsers.length}
              </div>
              <div className="text-lg font-medium text-gray-900">Users</div>
              <p className="text-sm text-gray-500 mt-1">
                View all users and when they were added
              </p>
            </div>

            <div
              onClick={openProjects}
              className="bg-white rounded-lg shadow-md border border-gray-200 p-6 hover:shadow-lg transition-shadow cursor-pointer text-center"
            >
              <div className="text-4xl font-bold text-purple-600 mb-2">
                {companyProjects.length}
              </div>
              <div className="text-lg font-medium text-gray-900">
                Projects
              </div>
              <p className="text-sm text-gray-500 mt-1">
                View all projects and their mappings
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyDetail;
